import { AppBar, Button, Card, CardContent, Dialog, DialogContent, Grid, IconButton, Toolbar, Typography } from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import CustomerDetailsEditable from './sections/CustomerDetails/CustomerDetailsEditable';
import request from '../../utils/request';
import { useDispatch, useSelector } from 'react-redux';
import { selectEndorsmentFormData, selectPolicyDetails, updateEndorsementFormData, updateEndorsementScreenNumber, updateSumInsuredSectionData } from 'src/features/rfqDataSlice';
import SumInsured from './sections/SumInsured';
import DynamicFormEditable from './sections/DynamicForms/DynamicFormEditable';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RiskDescriptionEditable from './sections/RiskDescription/RiskDescriptionEditable';
import SuggestedDeductibleEditable from './sections/suggestedDeductible/SuggestedDeductibleEditable';
import CoverageRemarkEditable from './sections/CoverageRemark/CoverageRemarkEditable';
import ClausesRemarkEditable from './sections/ClausesRemark/ClausesRemarkEditable';
import HypotheticalDetailsEditable from './sections/HypotheticalDetails/HypotheticalDetailsEditable';
import WarrantiesExclusionEditable from './sections/Warranties_exclusions/WarrantiesExclusionEditable';

function EndorsementUpdateScreenTwo({ closeModal, setShowSnackBarAlert }) {
    const policyDetailsData = useSelector(selectPolicyDetails);
    const endorsementFormData = useSelector(selectEndorsmentFormData);
    const [loader, setLoader] = React.useState(false);
    const dispatch = useDispatch();
    const goBack = () => {

        dispatch(
            updateEndorsementFormData({
                customerData: null,
                riskDescription: null,
                suggestedDeductible: null,
                hypothetical_details: [],
                warrantiesExclusions: null,
                clauseRemark: null,
                coverageRemark: null,
                dynamicFormData: null,
                secondDynamicFormData: null,
                thirdDynamicFormData: null,
                sumInsuredSectionData: []
            })
        )
        dispatch(updateEndorsementScreenNumber(1))
    }
    function buildStructuredDynamicForm(allfields, selectedFields) {
        if (!Array.isArray(allfields)) return [];

        const groupedResult = allfields.map((group, groupIndex) => {
            const matchedForms = selectedFields
                .filter((item) => item.id.startsWith(`${groupIndex}-`))
                .map((item) => item.data);

            return {
                groupName: group.groupName,
                masterForms: matchedForms,
                masterTemplateId: group.masterTemplateId || Math.random()
            };
        });


        return groupedResult.filter(group => group.masterForms.length > 0);
    }

    const submitEndorsement = () => {
        const structuredDynamicFormData1 = buildStructuredDynamicForm(policyDetailsData.dynamicFormData, endorsementFormData.dynamicFormData);
        const structuredDynamicFormData2 = buildStructuredDynamicForm(policyDetailsData.secondDynamicFormData, endorsementFormData.secondDynamicFormData);
        const structuredDynamicFormData3 = buildStructuredDynamicForm(policyDetailsData.thirdDynamicFormData, endorsementFormData.thirdDynamicFormData);
        let values = {
            policyId: endorsementFormData.policyId,
            type: endorsementFormData.type,
            subType: endorsementFormData.subType,
            description: endorsementFormData.description,
            endorsementData: {
                ...endorsementFormData,
                ...(endorsementFormData.type === 'Non-Financial' && {
                    customerData: {
                        insuredName: endorsementFormData.customerData.insuredNameValue ?? policyDetailsData?.customerData?.insuredName,
                        address: endorsementFormData.customerData.addressValue ?? policyDetailsData?.customerData?.address,
                        branchName: endorsementFormData.customerData.branchNameValue ?? policyDetailsData?.customerData?.branchName,
                        city: endorsementFormData.customerData.cityValue ?? policyDetailsData?.customerData?.city,
                        pincode: endorsementFormData.customerData.pincodeValue ?? policyDetailsData?.customerData?.pincode,
                        gstNo: endorsementFormData.customerData.gstNoValue ?? policyDetailsData?.customerData?.gstNo,
                    }
                }),
                dynamicFormData: structuredDynamicFormData1,
                secondDynamicFormData: structuredDynamicFormData2,
                thirdDynamicFormData: structuredDynamicFormData3,
                riskDescription: endorsementFormData?.riskDescription?.isSelected ? endorsementFormData?.riskDescription?.newValue : '',
                suggestedDeductible: endorsementFormData?.suggestedDeductible?.isSelected ? endorsementFormData?.suggestedDeductible?.newValue : '',
                coverageRemark: endorsementFormData?.coverageRemark?.isSelected ? endorsementFormData?.coverageRemark?.newValue : '',
                clausesRemark: endorsementFormData?.clausesRemark?.isSelected ? endorsementFormData?.clausesRemark?.newValue : '',
                hypothetical_details: endorsementFormData?.hypothetical_details ? endorsementFormData?.hypothetical_details : [],
            }
        };


        const URL = 'endorsement/createEndoresement';

        request({
            url: URL,
            method: 'POST',
            data: values,
        })
            .then((response) => {
                setLoader(false);
                setShowSnackBarAlert({
                    status: true,
                    type: response.status ? 'success' : 'error',
                    message: response['message'],
                });

                if (response.status) {
                    closeModal();
                }
            })
            .catch((err) => {
                setShowSnackBarAlert({
                    status: true,
                    type: 'error',
                    message: err.message,
                });
                setLoader(false);
            });
    };

    const gotToendorsementPreviewScreen = () => {
        dispatch(updateEndorsementScreenNumber(3))
    }

    return (
        <div>

            {/* Full-Screen Dialog */}
            <Dialog
                fullScreen
                open={true}
                onClose={closeModal}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={closeModal}
                            aria-label="close"
                            sx={{ marginLeft: 1 }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ flex: 1 }} variant="h6" component="div">
                            Policy Data
                        </Typography>

                    </Toolbar>
                </AppBar>

                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Card sx={{ marginBottam: '10px' }}>
                                <CardContent>
                                    <div style={{ textAlign: 'right' }}>
                                        <Button
                                            variant="outlined"
                                            startIcon={<ArrowBackIcon />}
                                            onClick={goBack}
                                            style={{ marginRight: '15px' }}
                                        >
                                            Back
                                        </Button>
                                        {/* <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={submitEndorsement}
                                        >
                                            Submit
                                        </Button> */}

                                        <Button
                                            style={{ marginLeft: '10px' }}
                                            variant="contained"
                                            color="success"
                                            onClick={gotToendorsementPreviewScreen}
                                        >
                                            Preview
                                        </Button>


                                    </div>

                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: '10px' }}>
                            <Card sx={{ marginBottam: '10px' }}>
                                <CardContent>
                                    {(() => {
                                        const customerData = endorsementFormData?.customerData || {};
                                        const editableFields = [
                                            'insuredName',
                                            'address',
                                            'branchName',
                                            'city',
                                            'pincode',
                                            'gstNo'
                                        ];

                                        const showCustomerEdit = editableFields.some(field => customerData[field] === true);

                                        return showCustomerEdit ? <CustomerDetailsEditable /> : null;
                                    })()}



                                    {endorsementFormData.dynamicFormData?.length > 0 && <DynamicFormEditable policyDetails={policyDetailsData} formNumber={1} />}
                                    {endorsementFormData.secondDynamicFormData?.length > 0 && <DynamicFormEditable policyDetails={policyDetailsData} formNumber={2} />}



                                    {(endorsementFormData?.type === 'Financial' || endorsementFormData?.type == 'Non-Financial' || endorsementFormData?.type === 'Both') &&
                                        policyDetailsData?.policySumInsuredSections?.length > 0 ? (
                                        <SumInsured />
                                    ) : null}
                                    {endorsementFormData.thirdDynamicFormData?.length > 0 && <DynamicFormEditable policyDetails={policyDetailsData} formNumber={3} />}
                                    {endorsementFormData?.riskDescription?.isSelected && <RiskDescriptionEditable />}
                                    {endorsementFormData?.coverageRemark?.isSelected && <CoverageRemarkEditable />}
                                    {endorsementFormData?.coverageRemark?.isSelected && <ClausesRemarkEditable />}
                                    {<HypotheticalDetailsEditable />}
                                    {endorsementFormData?.suggestedDeductible?.isSelected && <SuggestedDeductibleEditable />}
                                    {endorsementFormData?.warrantiesExclusions?.isSelected && <WarrantiesExclusionEditable />}


                                    {/* {JSON.stringify(endorsementFormData)} */}
                                </CardContent>
                            </Card>
                        </Grid>


                    </Grid>

                </DialogContent>


            </Dialog>
        </div>
    )
}

export default EndorsementUpdateScreenTwo